import { get } from 'lodash';
import { connect } from 'react-redux';

import { checkInteractionDiscovery, getSSPData } from '../../../screens/ChargerDetails/actions';
import { getDiagnosticAvailable } from '../../../screens/ChargerDetails/selectors';

import View from './component';

const mapStateToProps = (state) => ({
  userPermissions: get(state, 'login.user.currentPermissions'),
  labels: get(state, 'appConfig.config.ui_labels'),
  isDiagnosticsAvailable: getDiagnosticAvailable(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  checkInteractionDiscovery: () => {
    dispatch(checkInteractionDiscovery(ownProps.charger.c_uuid));
  },
  onGetDataAction: (id, props) => {
    dispatch(
      getSSPData(id, null, ownProps.charger.c_uuid, {
        ...props,
        url: `/chargers/${ownProps.charger.c_uuid}/control/tasks_list`,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
